import { render, staticRenderFns } from "./FormElements.vue?vue&type=template&id=54ea477c&"
import script from "./FormElements.vue?vue&type=script&lang=js&"
export * from "./FormElements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports